import {
  TradePortDetailInfo,
  ContainerTradeData,
  LoadDischargeData,
  TradeByPartner,
  Turnaround,
  PortcallTimeliness,
  FreightRateIndex,
  PartnerTradeTransit,
  LeadTimesNew,
  CountryTrade, PortContainerType, ContainersTerminal, DistributionCenter,
} from 'src/model/port';
import { getRequest } from 'src/services/api/http';
import { URL_ENDPOINT } from 'src/utils/constants/service';

const PortService = {
  getPortDetail,
  getDataContainerTradeChart,
  getDataLoadDischargeChart,
  getDataTradeByPartner,
  getDataTurnaround,
  getDataPortcallTimeliness,
  getDataFreightRateIndex,
  getDataPartnerTradeTransit,
  getDataLeadTimesNew,
  getDataCountryTrade,
  getDataContainerType,
  getDataContainersTerminal,
  getDataDistributionCenter,
};

export default PortService;

function getPortDetail(id: string) {
  const url = URL_ENDPOINT.port.ports + '/' + id;
  return getRequest(url, {}, new TradePortDetailInfo()) as Promise<TradePortDetailInfo>;
}

function getDataContainerTradeChart({ locode, freq }: { locode: string; freq: string }) {
  const url = URL_ENDPOINT.port.ports + '/sea-trade-by-week';
  return getRequest(url, { locode, freq }, new ContainerTradeData()) as Promise<ContainerTradeData>;
}

function getDataLoadDischargeChart({ locode }: { locode: string }) {
  const url = URL_ENDPOINT.port.ports + '/port-waiting-times';
  return getRequest(url, { locode }, new LoadDischargeData()) as Promise<LoadDischargeData>;
}

function getDataTradeByPartner({ locode, isExport }: { locode: string; isExport: number }) {
  const url = URL_ENDPOINT.port.ports + '/trade-by-partner-series';
  return getRequest(
    url,
    { locode, is_export: isExport, agg: 'month' },
    new TradeByPartner(),
  ) as Promise<TradeByPartner>;
}

function getDataTurnaround({ locode }: { locode: string }) {
  const url = URL_ENDPOINT.port.ports + '/turnaround';
  return getRequest(url, { locode }, new Turnaround()) as Promise<Turnaround>;
}

function getDataPortcallTimeliness({ locode }: { locode: string }) {
  const url = URL_ENDPOINT.port.ports + '/portcall-timeliness';
  return getRequest(url, { locode }, new PortcallTimeliness()) as Promise<PortcallTimeliness>;
}

function getDataFreightRateIndex({ locode, locodeDestination }: { locode: string; locodeDestination: string }) {
  const url = URL_ENDPOINT.port.ports + '/freight-rate-index';
  return getRequest(
    url,
    { locode, locode_destination: locodeDestination },
    new FreightRateIndex(),
  ) as Promise<FreightRateIndex>;
}

function getDataPartnerTradeTransit({ page, pageSize }: { page: number; pageSize: number }) {
  const url = URL_ENDPOINT.port.ports + '/dropdown';
  return getRequest(url, { page, page_size: pageSize }, new PartnerTradeTransit()) as Promise<PartnerTradeTransit>;
}

function getDataLeadTimesNew({
  locode,
  locodePartner,
  isExport,
}: {
  locode: string;
  locodePartner: string;
  isExport: number;
}) {
  const url = URL_ENDPOINT.port.ports + '/lead-times-new';
  return getRequest(
    url,
    { locode, locode_partner: locodePartner, is_export: isExport },
    new LeadTimesNew(),
  ) as Promise<LeadTimesNew>;
}

function getDataCountryTrade({
  locode,
  locodePartner,
  freq,
  isExport,
}: {
  locode: string;
  locodePartner: string;
  freq: string;
  isExport: number;
}) {
  const url = URL_ENDPOINT.port.ports + '/country-to-country-trade';
  return getRequest(
    url,
    { locode, locode_partner: locodePartner, is_export: isExport, freq },
    new CountryTrade(),
  ) as Promise<CountryTrade>;
}
function getDataContainerType({ locode }: { locode: string }) {
  const url = URL_ENDPOINT.port.ports + '/container-type-table';
  return getRequest(url, { locode }, new PortContainerType()) as Promise<PortContainerType>;
}

function getDataContainersTerminal({ locode }: { locode: string }) {
  const url = URL_ENDPOINT.port.ports + '/containers-in-terminal';
  return getRequest(url, { locode }, new ContainersTerminal()) as Promise<ContainersTerminal>;
}

function getDataDistributionCenter({ locode, isLast }: { locode: string; isLast: number }) {
  const url = URL_ENDPOINT.port.ports + '/distribution-centers';
  return getRequest(url, { locode, is_last: isLast }, new DistributionCenter()) as Promise<DistributionCenter>;
}
